const SERVICE_LABELS = {
  coupe: "Coupe",
  brushing: "Brushing",
  couleur: "Couleur",
  "mèches": "Mèches",
  lissage: "Lissage",
  permanente: "Permanente",
  barbe: "Barbe"
};

const DETAIL_LABELS = {
  coupe: "Coupe",
  couleur: "Couleur",
  "mèches": "Mèches"
};

function toServiceLabel(value) {
  return SERVICE_LABELS[value] || value;
}

export function parseStructuredAppointmentDetails(rawDetails) {
  if (!rawDetails || typeof rawDetails !== "string") {
    return null;
  }

  try {
    const parsed = JSON.parse(rawDetails);
    if (!parsed || typeof parsed !== "object" || !parsed.services) {
      return null;
    }

    const selectedRaw = Array.isArray(parsed.services.selected) ? parsed.services.selected : [];
    const selected = selectedRaw.map((service) => toServiceLabel(service));

    const detailsRaw = parsed.services.details && typeof parsed.services.details === "object"
      ? parsed.services.details
      : {};

    const details = Object.entries(detailsRaw)
      .filter(([, value]) => !!value)
      .map(([key, value]) => ({
        key,
        label: DETAIL_LABELS[key] || key,
        value: String(value)
      }));

    return {
      length: parsed.hair?.length || "",
      thickness: parsed.hair?.thickness || "",
      services: selected,
      details
    };
  } catch {
    return null;
  }
}

export function structuredServiceSummary(parsedDetails) {
  if (!parsedDetails) {
    return "";
  }

  const servicesPart = parsedDetails.services.length > 0
    ? parsedDetails.services.join(", ")
    : "Aucun";

  const detailsPart = parsedDetails.details.length > 0
    ? ` (${parsedDetails.details.map((d) => `${d.label}: ${d.value}`).join("; ")})`
    : "";

  return `Services : ${servicesPart}${detailsPart}`;
}

export function structuredHairSummary(parsedDetails) {
  if (!parsedDetails) {
    return "";
  }

  const parts = [];
  if (parsedDetails.length) {
    parts.push(`Longueur : ${parsedDetails.length}`);
  }
  if (parsedDetails.thickness) {
    parts.push(`Epaisseur : ${parsedDetails.thickness}`);
  }

  return parts.join(" | ");
}
